import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { updateUserAccountSettings, cancelUpdate } from '../../actions/customerPortal';
import { storeWithExpiration } from '../../utils/common';
import UserSettingsForm from './UserSettingsForm';

const FORM_ID = 'userSettingsForm';

export class UserSettings extends React.Component {
  static propTypes = {
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    updateUserAccountSettingsAction: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
  };

  performAccountUpdate = params => {
    const { updateUserAccountSettingsAction, user } = this.props;
    const token = storeWithExpiration.get('token');
    const userObj = user.toObject();
    userObj.firstName = params.firstName && params.firstName.trim();
    userObj.lastName = params.lastName && params.lastName.trim();

    updateUserAccountSettingsAction(userObj, token);
  };

  render() {
    const { invalid, handleSubmit, submitting } = this.props;

    return (
      <UserSettingsForm
        invalid={invalid}
        handleSubmit={handleSubmit}
        updateAccountFunction={this.performAccountUpdate}
        submitting={submitting}
      />
    );
  }
}

const validate = values => {
  const errors = {};

  if (!values.firstName || values.firstName.trim() === '') {
    errors.firstName = 'Required';
  }
  if (!values.lastName || values.lastName.trim() === '') {
    errors.lastName = 'Required';
  }

  return errors;
};

const UserSettingsRF = reduxForm({
  form: FORM_ID,
  validate,
  enableReinitialize: true,
})(UserSettings);

function mapStateToProps(state) {
  const { account, user } = state;
  const initialValues = { firstName: user.firstName, lastName: user.lastName };
  return { account, initialValues, user };
}

export default connect(mapStateToProps, {
  cancelSettingsUpdateAction: cancelUpdate,
  updateUserAccountSettingsAction: updateUserAccountSettings,
})(UserSettingsRF);
